import { GETObjectDataParamsEnriched } from '@types'

const isNotEmptyValue = (value: unknown) => {
  return value !== undefined && value !== null && value !== ''
}

const getValueByPath = (source: unknown, path: string) => {
  const pathParts = path.split('.').filter(Boolean)

  let currentValue = source

  for (const pathPart of pathParts) {
    if (Array.isArray(currentValue)) {
      currentValue = currentValue
        .map(item => {
          if (!item || typeof item !== 'object') {
            return undefined
          }

          return (item as Record<string, unknown>)[pathPart]
        })
        .filter(isNotEmptyValue)

      continue
    }

    if (!currentValue || typeof currentValue !== 'object') {
      return undefined
    }

    currentValue = (currentValue as Record<string, unknown>)[pathPart]
  }

  if (Array.isArray(currentValue)) {
    return currentValue
      .flatMap(item => (Array.isArray(item) ? item : [item]))
      .filter(isNotEmptyValue)
      .join(', ')
  }

  return currentValue
}

const getFlatPathAlias = (path: string) => {
  return path
    .split('.')
    .filter(Boolean)
    .map((pathPart, index) => {
      if (index > 0 && pathPart.startsWith('_')) {
        return pathPart.slice(1)
      }

      return pathPart
    })
    .join('_')
}

export const getDefaultDropdownLabelValue = (
  item: GETObjectDataParamsEnriched,
  objectValue: string
) => {
  const directValue = getValueByPath(item, objectValue)

  if (isNotEmptyValue(directValue)) {
    return directValue
  }

  const flatPathAlias = getFlatPathAlias(objectValue)
  const flatPathAliasValue = getValueByPath(item, flatPathAlias)

  if (isNotEmptyValue(flatPathAliasValue)) {
    return flatPathAliasValue
  }

  const pathParts = objectValue.split('.').filter(Boolean)

  if (pathParts.length < 2) {
    return undefined
  }

  const displayField = pathParts[pathParts.length - 1]
  const refPathParts = pathParts.slice(0, -1)

  const expandPath = [...refPathParts.map(pathPart => `expands_${pathPart}`), displayField].join(
    '.'
  )

  return getValueByPath(item, expandPath)
}
